
define('jst!filefinder/_tab_error',['underscore','translate'],function () { var _ = require('underscore');
var t = require('translate');
return _.template('<div class="message-wrapper">\n  <div class="error-message">\n    <p><%= message %></p>\n    \n    <% if(showButton) { %>\n      <%- button(buttonText, \'\', { \'class\':\'{0} {1}\'.format(buttonClass, identifier), \'color\': \'secondary baby-button\' }) %>\n    <% } %>\n  </div>\n</div>');
 });

